<template>
	<l-table ref="table" row-key="id" :data="data" :height="height" v-bind="$attrs" v-on="$listeners">
		<el-table-column type="selection" width="45" v-if="!readonly" :reserve-selection="reserveSelection"> </el-table-column>
		<!-- <el-table-column fixed prop="index" label="序号" width="100"></el-table-column> -->
		<el-table-column prop="dev_no" label="资产编号" min-width="150"></el-table-column>
		<el-table-column prop="dev_type_id" label="资产类型" min-width="150">
			<template v-slot="{ row }"> {{ row.p_dev_type_name }} - {{ row.dev_type_name }} </template>
		</el-table-column>
		<el-table-column prop="dev_name" label="资产名称" min-width="150"></el-table-column>
		<el-table-column prop="dev_state" label="资产状态" min-width="150">
			<template v-slot="{ row }">
				<l-assets-state :state="row.dev_state"></l-assets-state>
			</template>
		</el-table-column>
		<el-table-column prop="manage_org_name" label="管理组织" min-width="150" show-overflow-tooltip></el-table-column>
		<el-table-column prop="use_org_name" label="使用组织" min-width="150" show-overflow-tooltip></el-table-column>
		<el-table-column prop="use_user_name" label="使用人" min-width="100" show-overflow-tooltip></el-table-column>
		<el-table-column prop="manage_user_name" label="管理人" min-width="100" show-overflow-tooltip></el-table-column>
		<el-table-column prop="hall_name" label="营业厅/办公点" min-width="200" show-overflow-tooltip></el-table-column>
		<el-table-column label="存放区域" min-width="200" show-overflow-tooltip>
			<template v-slot="{ row }">
				{{ row.prov + row.city + row.area }}
			</template>
		</el-table-column>
		<el-table-column prop="address" label="详细地址" min-width="250" show-overflow-tooltip> </el-table-column>
		<el-table-column prop="entry_date" label="入库时间" min-width="110" show-overflow-tooltip> </el-table-column>
		<el-table-column prop="entry_date" label="金额" min-width="150" show-overflow-tooltip>
			<template v-slot="{ row }">
				<span v-show="row.dev_value"> {{ row.dev_value }}元 </span>
			</template>
		</el-table-column>
		<el-table-column fixed="right" label="操作" width="100" align="center" v-if="!readonly">
			<template slot-scope="{ row }">
				<l-text-button type="danger" style="margin-left: 10px" @click="del(row)">移除</l-text-button>
			</template>
		</el-table-column>
	</l-table>
</template>

<script>
import States from "./States.vue";
export default {
	name: "l-assets-common-table",
	components: {
		[States.name]: States,
	},
	props: {
		data: {
			type: Array,
			required: true,
		},
		height: {
			type: [Number, String],
			default: "450px",
		},

		readonly: {
			type: Boolean,
			default: false,
		},

		reserveSelection: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {};
	},

	methods: {
		//移除
		del(row) {
			this.$emit("del", row);
		},

		//清空所有选择
		clearSelection() {
			this.$refs.table.clearSelection();
		},

		toggleRowSelection(row, selected) {
			this.$refs.table.toggleRowSelection(row, selected);
		},
	},
};
</script>
